import { DeleteOutlined, PlusOutlined, SaveOutlined, SendOutlined, UndoOutlined, CloseOutlined, CheckOutlined } from '@ant-design/icons';
import ModalTextForm from '@app/components/modal/ModalTextForm';
import { Button, Col, Form, Input, Row, Space, Table, Tabs, Tag } from 'antd';
import Column from 'antd/es/table/Column';
import dayjs from 'dayjs';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import { trangThaiDangKyDaoTao, urlAdmin } from '../../constants';
import { Links } from '../../helpers/Links';
import { menuHelper } from "../../helpers/account";
import { dateCommon, shortFileName, validateMessages } from '../../helpers/common';
import { ChiTietDangKyDaoTao, LopThamGia, NhomDaoTao } from '../../models/daotao/DangKyDaoTao';
import { layChiTietDangKyDaoTao, layDSLopThamGia, luuDangKyDaoTao, thuHoiDangKyDaoTao, vanPhongTuChoiDKDT, xoaDangKyDaoTao } from '../../services/daotao';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import LogNguoiDungTable from '../utils/LogNguoiDungTable';
import TrangThaiTag from './TrangThaiTag';

const ChiTietCaNhan = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const user = useSelector((state: any) => state.auth.currentUser);
    const [trangThai, setTrangThai] = useState<number>(0);
    const [id, setId] = useState<number>(0);
    const [data, setData] = useState<any>({});
    const [nhomDaoTao, setNhomDaoTao] = useState<Array<NhomDaoTao>>([]);
    const menu: any = menuHelper.checkMultiPermission([Links.DangKyDaoTao.PheDuyetCaNhan, Links.DangKyDaoTao.ChiTiet]);
    const [lyDo, setLyDo] = useState<string>("");
    const [isDuyet, setIsDuyet] = useState(false);
    const [isTrinh, setIsTrinh] = useState(false);
    const [confirmModal, setConfirmModal] = useState<any>({});
    const [showErrors, setShowErrors] = useState(false);
    const [dsThamGia, setDsThamGia] = useState<{ [idNhom: number]: LopThamGia[] }>({});
    const [showThamGia, setShowThamGia] = useState<{ [idNhom: number]: boolean }>({});
    const [loadingThamGia, setLoadingThamGia] = useState<{ [idNhom: number]: boolean }>({});
    const onFinish = (values: any) => {
        const allChiTiets = nhomDaoTao.flatMap(nhom => nhom.chiTiets || []);

        if (allChiTiets.length === 0) {
            toast.warning("Vui lòng nhập ít nhất một dòng dữ liệu!");
            return;
        }

        const invalidRow = allChiTiets.some(item =>
            !(item.chuyenDe || '').trim() ||
            !(item.noiDung || '').trim() ||
            !(item.coSoDaoTao || '').trim() ||
            !(item.thoiGianDuKien || '').trim() ||
            !(item.duTruKinhPhi || '').trim()
        );

        if (invalidRow) {
            setShowErrors(true);
            toast.warning("Vui lòng nhập đầy đủ thông tin cho tất cả các dòng!");
            return;
        }
        setShowErrors(false);
        const saveData = {
            id: data.id,
            idDangKyDaoTaoNam: data.idDangKyDaoTaoNam,
            isTrinh: isTrinh,
            isDuyet: isDuyet,
            isLanhDaoPhong: lanhDaoPhong,
            chiTiets: allChiTiets
        };
        if (lanhDaoPhong) {
            setConfirmModal({
                isShowModal: true,
                title: isDuyet ? "Phê duyệt đăng ký đào tạo" : "Từ chối đăng ký đào tạo",
                content: isDuyet ? <>Bạn có muốn <strong>Duyệt</strong> bản đăng ký đào tạo này không? Hãy nhập nội dung (nếu có)</>
                    : <>Bạn có muốn <strong>Từ chối</strong> bản đăng ký đào tạo này không? Hãy nhập nội dung (nếu có)</>,
                onSubmit: (currentLyDo: string) => submitLuu(saveData, currentLyDo),
                showLyDo: true
            });
        } else {
            setConfirmModal({
                isShowModal: true,
                title: isTrinh ? "Lưu & trình đăng ký đào tạo"
                    : (id > 0 ? "Cập nhật Đăng ký nhu cầu đào tạo" : "Thêm mới Đăng ký nhu cầu đào tạo"),
                content: isTrinh ? <>Bạn có muốn <strong>Lưu và trình</strong> bản đăng ký đào tạo này không? Hãy nhập nội dung (nếu có)</>
                    : (id > 0 ? <>Bạn có muốn <strong>Cập nhật</strong> Đăng ký nhu cầu đào tạo này không</> : <>Bạn có muốn <strong>Thêm mới</strong> Đăng ký nhu cầu đào tạo này không?</>),
                onSubmit: (currentLyDo: string) => submitLuu(saveData, currentLyDo),
                showLyDo: isTrinh
            });
        }
    };

    const handleAddChiTiet = (id: number) => {
        setNhomDaoTao(prev =>
            prev.map(nhom => {
                if (nhom.id === id) {
                    const newChiTiet: ChiTietDangKyDaoTao = {
                        key: Date.now(),
                        id: 0,
                        idDangKyDaoTao: 0,
                        idNhomDaoTao: id,
                        thuTu: (nhom.chiTiets?.length || 0) + 1,
                        chuyenDe: '',
                        noiDung: '',
                        coSoDaoTao: '',
                        thoiGianDuKien: '',
                        duTruKinhPhi: '',
                        trangThai: -1
                    };

                    return {
                        ...nhom,
                        chiTiets: [...(nhom.chiTiets || []), newChiTiet]
                    };
                }
                return nhom;
            })
        );
    };

    const updateNhom = (idNhom: number, index: number, field: string, value: any) => {
        setNhomDaoTao(prev =>
            prev.map(nhom => {
                if (nhom.id === idNhom) {
                    const updatedChiTiets = (nhom.chiTiets || []).map((ct, i) => {
                        if (i === index) {
                            return {
                                ...ct,
                                [field]: value
                            };
                        }
                        return ct;
                    });

                    return {
                        ...nhom,
                        chiTiets: updatedChiTiets
                    };
                }
                return nhom;
            })
        );
    };

    const handleXoaChiTiet = (idNhom: number, index: number) => {
        setNhomDaoTao(prev =>
            prev.map(nhom => {
                if (nhom.id === idNhom) {
                    const newChiTiets = [...(nhom.chiTiets || [])];
                    newChiTiets.splice(index, 1);

                    return {
                        ...nhom,
                        chiTiets: newChiTiets
                    };
                }
                return nhom;
            })
        );
    };

    const loadThamGia = async (idNhom: number) => {
        setLoadingThamGia(prev => ({ ...prev, [idNhom]: true }));
        try {
            const rs = await layDSLopThamGia(data.idDangKyDaoTaoNam, idNhom);
            setDsThamGia(prev => ({ ...prev, [idNhom]: rs || [] }));
        } catch (e: any) {
            toast.error("Không lấy được danh sách lớp có thể tham gia");
        }
        setLoadingThamGia(prev => ({ ...prev, [idNhom]: false }));
    };

    const toggleThamGia = (idNhom: number) => {
        setShowThamGia(prev => {
            const next = !prev[idNhom];
            if (next && dsThamGia[idNhom] === undefined) {
                loadThamGia(idNhom);
            }
            return { ...prev, [idNhom]: next };
        });
    };

    const handleThamGia = (idNhom: number, lop: LopThamGia) => {
        setNhomDaoTao(prev =>
            prev.map(nhom => {
                if (nhom.id !== idNhom) return nhom;
                const newChiTiet: ChiTietDangKyDaoTao = {
                    key: Date.now(),
                    id: 0,
                    idDangKyDaoTao: 0,
                    idNhomDaoTao: idNhom,
                    idChiTietGoc: lop.id,
                    thuTu: (nhom.chiTiets?.length || 0) + 1,
                    chuyenDe: lop.chuyenDe,
                    noiDung: lop.noiDung,
                    coSoDaoTao: lop.coSoDaoTao,
                    thoiGianDuKien: lop.thoiGianDuKien,
                    duTruKinhPhi: lop.duTruKinhPhi
                };
                return { ...nhom, chiTiets: [...(nhom.chiTiets || []), newChiTiet] };
            })
        );
    };

    const handleHuyThamGia = (idNhom: number, idChiTietGoc: number) => {
        setNhomDaoTao(prev =>
            prev.map(nhom => {
                if (nhom.id !== idNhom) return nhom;
                return { ...nhom, chiTiets: (nhom.chiTiets || []).filter(ct => ct.idChiTietGoc !== idChiTietGoc) };
            })
        );
    };

    const daThamGia = (idNhom: number, lopId: number) => {
        const nhom = nhomDaoTao.find(n => n.id === idNhom);
        return (nhom?.chiTiets || []).some(ct => ct.idChiTietGoc === lopId);
    };

    const eventDelete = async () => {
        dispatch(showLoadingScreen());
        try {
            await xoaDangKyDaoTao(id);
            navigate(Links.DangKyDaoTao.DanhSachCaNhan);
            toast.success("Xóa đăng ký nhu cầu đào tạo thành công");
        }
        catch (e: any) {
            toast.error("Xóa đăng ký nhu cầu đào tạo không thành công");
        };

        dispatch(hideLoadingScreen());
    }

    const eventThuHoi = async (currentLyDo?: string) => {
        dispatch(showLoadingScreen())
        try {
            await thuHoiDangKyDaoTao({ id: data.id, lyDo: currentLyDo || lyDo });
            toast.success("Thu hồi Đăng ký đào tạo thành công");
            setLyDo("");
            layDuLieu(id, data.idDangKyDaoTaoNam);
        } catch (e: any) {
            toast.error("Thu hồi Đăng ký đào tạo không thành công");
        }
        dispatch(hideLoadingScreen());
    }

    const eventVPTuChoi = async (currentLyDo?: string) => {
        dispatch(showLoadingScreen())
        try {
            await vanPhongTuChoiDKDT({ id: data.id, lyDo: currentLyDo || lyDo });
            toast.success("Từ chối Đăng ký đào tạo thành công");
            setLyDo("");
            navigate(Links.DangKyDaoTao.Xem + "?id=" + data.idDangKyDaoTaoNam + "&tab=2");
        } catch (e: any) {
            toast.error("Từ chối Đăng ký đào tạo không thành công");
        }
        dispatch(hideLoadingScreen());
    }

    const submitLuu = async (value: any, currentLyDo?: string) => {
        try {
            dispatch(showLoadingScreen());
            await luuDangKyDaoTao({ ...value, lyDo: currentLyDo || lyDo, idDonVi: data.idDonVi, tenDonVi: data.tenDonVi, idChucVu: data.idChucVu });
            dispatch(showLoadingScreen());
            if (lanhDaoPhong) {
                toast.success(isDuyet ? "Phê duyệt đăng ký nhu cầu đào tạo thành công" : 'Từ chối Đăng ký nhu cầu đào tạo thành công!');
                navigate(Links.DangKyDaoTao.PheDuyetCaNhan + "?nam=" + dateCommon.formatDate(data?.nam, "yyyy") + "&id=" + data?.idDangKyDaoTaoNam);
            } else {
                toast.success(isTrinh ? "Lưu và Trình đăng ký nhu cầu đào tạo thành công" : id > 0 ? 'Cập nhật Đăng ký nhu cầu đào tạo thành công!' : 'Tạo mới Đăng ký nhu cầu đào tạo thành công!');
                navigate(Links.DangKyDaoTao.DanhSachCaNhan);
            }
            dispatch(hideLoadingScreen());
        }
        catch (error: any) {
            dispatch(hideLoadingScreen());
            toast.error(error.message || "Vui lòng thử lại");
        };
    };

    const layDuLieu = async (idData: number, idDangKyDaoTaoNam: number) => {
        try {
            dispatch(showLoadingScreen());
            let rs = await layChiTietDangKyDaoTao(idData, idDangKyDaoTaoNam);
            if (rs.trangThai == trangThaiDangKyDaoTao.chuaDangKy) {
                setId(0);
            } else {
                setId(idData);
            }
            if (idData == 0) {
                rs.idNhanVien = user.idNhanVien;
            }
            setData(rs);
            setTrangThai(rs.trangThai);
            setNhomDaoTao(rs?.nhomDaoTaos || []);
            dispatch(hideLoadingScreen());
        }
        catch (error: any) {
            const message =
                error?.message ||
                error?.response?.data?.thongBao ||
                error?.toString() ||
                "Có lỗi xảy ra";
            toast.error(message);
            navigate(Links.DangKyDaoTao.DanhSachCaNhan);
            dispatch(hideLoadingScreen());
        };
    }
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        var idData = params.get('id') || 0;
        var idDangKyDaoTaoNam = params.get("idDangKyDaoTaoNam") || 0;
        layDuLieu(idData, idDangKyDaoTaoNam);
    }, []);
    const lanhDaoPhong = false /*(trangThai == trangThaiDangKyDaoTao.trinhLanhDaoPhong || trangThai == trangThaiDangKyDaoTao.vanPhongTraLai)
        && menu[Links.DangKyDaoTao.PheDuyetCaNhan] && user.isLanhDaoPhong && data.idNhanVien != user.idNhanVien && data.idDonVi == user.idDonVi;*/
    const nhanVienVP = false //menu[Links.DangKyDaoTao.ChiTiet] && trangThai == trangThaiDangKyDaoTao.chuyenVanPhong;
    const isEditable = (user.idNhanVien == data.idNhanVien && [trangThaiDangKyDaoTao.chuaDangKy, trangThaiDangKyDaoTao.khoiTao, trangThaiDangKyDaoTao.thuHoi].includes(trangThai))
        || (user.isLanhDaoPhong && user.idNhanVien == data.idNhanVien && trangThai == trangThaiDangKyDaoTao.lanhDaoQuyTuChoi);
    const [activeTab, setActiveTab] = useState<string>("1");

    return <section>
        <ContentHeader title="Chi tiết đăng ký nhu cầu đào tạo" />
        <ModalTextForm
            show={confirmModal.isShowModal}
            title={confirmModal.title}
            handleClose={() => setConfirmModal({ isShowModal: false })}
            handleSave={() => {
                if (confirmModal.onSubmit) confirmModal.onSubmit(lyDo);
                setConfirmModal({ isShowModal: false });
            }}
        >
            <Row>
                <Col span="24">
                    {confirmModal.content}
                </Col>
            </Row>
            {
                confirmModal.showLyDo &&
                <Row>
                    <Col span="24">
                        <Input.TextArea
                            rows={2}
                            value={lyDo}
                            onChange={(e) => {
                                setLyDo(e.target.value);
                            }}
                        />
                    </Col>
                </Row>
            }
        </ModalTextForm>
        <Tabs
            defaultActiveKey="1"
            onChange={(key) => setActiveTab(key)}
            items={[
                {
                    key: "1",
                    label: "Chi tiết đợt đăng ký",
                    children:
                        <Row>
                            <Col span="24" className="card card-body">
                                <Form
                                    layout="vertical"
                                    validateMessages={validateMessages}
                                    form={form}
                                    onFinish={onFinish}
                                    initialValues={{
                                        nam: dayjs()
                                    }}
                                >
                                    <Row gutter={12} className="mb-2">
                                        <Col span={24}>
                                            <div>
                                                <div>Tên đợt đăng ký</div>
                                                <label><strong>{data?.ten}</strong></label>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row gutter={12} align="middle">
                                        <Col span="6">
                                            <div >
                                                <div>Họ và tên</div>
                                                <label>{data?.hoTen || user.hoTen} </label>
                                            </div>
                                        </Col>
                                        <Col span="4">
                                            <div className="mb-1">
                                                <div>Phòng ban</div>
                                                <label>{data?.tenDonVi} </label>
                                            </div>
                                        </Col>
                                        <Col span="4">
                                            <div className="mb-1">
                                                <div>Năm đăng ký</div>
                                                <label>{dateCommon.formatDate(data?.nam, "yyyy")} </label>
                                            </div>
                                        </Col>
                                        <Col span="6">
                                            <div className="mb-1">
                                                <div>Thời gian đăng ký</div>
                                                <label>{dateCommon.formatDate(data?.ngayBatDau)} - {dateCommon.formatDate(data?.ngayKetThuc)}</label>
                                            </div>
                                        </Col>
                                        <Col span={4}>
                                            <Form.Item label="Trạng thái" style={{ marginBottom: 0 }}>
                                                <label><TrangThaiTag value={data.trangThai} /></label>
                                            </Form.Item>
                                        </Col>
                                        {
                                            (data.dsTaiLieu || []).length > 0 &&
                                            <Col span={24} style={{ marginTop: "6px" }}>
                                                <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                                                    <label style={{ minWidth: "120px" }}>File đính kèm đợt:</label>
                                                    {(data.dsTaiLieu || []).map((file: any, index: number) => (
                                                        <span key={index} style={{ fontWeight: 500 }}>
                                                            <a
                                                                href={urlAdmin + file.duongDan?.replace(/\\/g, "/")}
                                                                download={file.tenTep}
                                                            >
                                                                <Button
                                                                    className="hrm-btn hrm-btn-sm hrm-btn-success"
                                                                    title={file.tenTep}
                                                                >
                                                                    <i className="fa fa-download mr-2" />
                                                                    {shortFileName(file.tenTep)}
                                                                </Button>
                                                            </a>
                                                        </span>
                                                    ))}
                                                </div>
                                            </Col>
                                        }
                                    </Row>
                                    <div style={{ position: "fixed", zIndex: 1, right: "25px", top: "120px" }}>
                                                    {
                                                        // Button thu hồi
                                                        trangThai == trangThaiDangKyDaoTao.trinhLanhDaoPhong
                                                        && nhomDaoTao.every(nhom =>
                                                            nhom.chiTiets.every(chiTiet =>
                                                                chiTiet.trangThai === trangThaiDangKyDaoTao.trinhLanhDaoPhong
                                                            )
                                                        )
                                                        && data.idNhanVien == user.idNhanVien &&
                                                        <Button
                                                            type="primary"
                                                            className="hrm-btn-warning"
                                                            icon={<UndoOutlined rev="" />}
                                                            onClick={() => {
                                                                setConfirmModal({
                                                                    isShowModal: true,
                                                                    title: "Thu hồi",
                                                                    content:
                                                                        <>Bạn có muốn <strong>Thu hồi</strong> bản đăng ký đào tạo này không? Hãy nhập lý do (nếu có)</>,
                                                                    onSubmit: eventThuHoi,
                                                                    showLyDo: true
                                                                });
                                                            }}
                                                        >
                                                            Thu hồi
                                                        </Button>
                                                    }
                                              {/*      {
                                                        lanhDaoPhong &&
                                                        <Space>
                                                            <Button
                                                                type="primary"
                                                                icon={<SendOutlined rev="" />}
                                                                htmlType="submit"
                                                                onClick={() => {
                                                                    setIsDuyet(true);
                                                                }}
                                                            >
                                                                Phê duyệt
                                                            </Button>
                                                            <Button
                                                                type="primary"
                                                                className="hrm-btn-delete"
                                                                icon={<CloseOutlined rev="" />}
                                                                htmlType="submit"
                                                                onClick={() => {
                                                                    setIsDuyet(false);
                                                                }}
                                                            >
                                                                Từ chối
                                                            </Button>
                                                        </Space>
                                                    }
                                                    {
                                                        nhanVienVP &&
                                                        <Space>
                                                            <Button
                                                                type="primary"
                                                                className="hrm-btn-delete"
                                                                icon={<CloseOutlined rev="" />}
                                                                htmlType="button"
                                                                onClick={() => {
                                                                    setConfirmModal({
                                                                        isShowModal: true,
                                                                        title: "Văn phòng từ chối",
                                                                        content:
                                                                            <>Bạn có muốn <strong>Từ chối</strong> bản đăng ký đào tạo này không? Hãy nhập lý do (nếu có)</>,
                                                                        onSubmit: eventVPTuChoi,
                                                                        showLyDo: true
                                                                    });
                                                                }}
                                                            >
                                                                Từ chối
                                                            </Button>
                                                        </Space>
                                                    }*/}
                                                    {isEditable && <Space>
                                                        {(!user.isLanhDaoPhong || data?.idBanDieuHanh > 0) && <Button
                                                            type="primary"
                                                            icon={<SendOutlined rev="" />}
                                                            htmlType="submit"
                                                            onClick={() => {
                                                                setIsTrinh(true);
                                                            }}
                                                        >
                                                            Lưu & Trình
                                                        </Button>}
                                                        <Button
                                                            type="primary"
                                                            htmlType="submit"
                                                            icon={<SaveOutlined />}
                                                            onClick={() => {
                                                                setIsTrinh(false);
                                                            }}
                                                        >
                                                            Lưu
                                                        </Button>
                                                        {[trangThaiDangKyDaoTao.khoiTao, trangThaiDangKyDaoTao.thuHoi, trangThaiDangKyDaoTao.lanhDaoPhongTuChoi].includes(trangThai) &&
                                                            <Button
                                                                icon={<DeleteOutlined rev="" />}
                                                                className="hrm-btn-delete"
                                                                onClick={() => {
                                                                    setLyDo("");
                                                                    setConfirmModal({
                                                                        isShowModal: true,
                                                                        title: "Xóa đăng ký đào tạo",
                                                                        content:
                                                                            <>Bạn có muốn <strong>Xóa</strong> thông tin đăng ký này không?</>,
                                                                        onSubmit: eventDelete,
                                                                        showLyDo: false
                                                                    });
                                                                }}
                                                            >
                                                                Xóa
                                                            </Button>}
                                                    </Space>}
                                    </div>
                                </Form>
                            </Col>
                        </Row>
                },
                {
                    key: '2',
                    label: "Lịch sử thao tác",
                    children: <LogNguoiDungTable data={data.logs} />
                },
            ]} />

        {activeTab === "1" &&
            nhomDaoTao.filter(x => isEditable || (x.chiTiets && x.chiTiets.length > 0)).map((x: NhomDaoTao, idx: number) => {
                const dsChuaThamGia = (dsThamGia[x.id] || []).filter(l => !daThamGia(x.id, l.id));
                return (
                    <Row key={x.id}>
                        <Col span="24">
                            <div className="card-outline">
                                <Tabs
                                    tabBarExtraContent=
                                    {
                                        isEditable ? (
                                            <Button className="hrm-btn hrm-btn-warning"
                                                icon={<PlusOutlined rev="" />}
                                                onClick={() => {
                                                    handleAddChiTiet(x.id);
                                                    if (!showThamGia[x.id]) { toggleThamGia(x.id); }
                                                }}
                                            >
                                                Thêm mới
                                            </Button>
                                        ) : undefined
                                    }
                                    defaultActiveKey="1" items={[
                                        {
                                            key: x.id + "n",
                                            label: x.ten,
                                            children:
                                                <Table
                                                    locale={{ emptyText: "Không có dữ liệu" }}
                                                    dataSource={x.chiTiets}
                                                    pagination={false}
                                                    rowKey="id"
                                                >
                                                    <Column
                                                        title="STT"
                                                        key="STT"
                                                        render={(value, record, index) =>
                                                        (
                                                            <>
                                                                {index + 1}
                                                            </>
                                                        )
                                                        }
                                                    />
                                                    <Column title="Chuyên đề đào tạo" dataIndex="chuyenDe" key="chuyenDe"
                                                        render={(text, record: any, index) =>
                                                            isEditable && !record.idChiTietGoc
                                                                ? <Input.TextArea autoSize={{ minRows: 1 }} status={showErrors && !(text || '').trim() ? 'error' : ''} value={text} onChange={(e) => updateNhom(x.id, index, 'chuyenDe', e.target.value)} />
                                                                : <span className="text-enter">{text}</span>
                                                        }
                                                    />
                                                    <Column title="Nội dung đào tạo" dataIndex="noiDung" key="noiDung"
                                                        render={(text, record: any, index) =>
                                                            isEditable && !record.idChiTietGoc ? <Input.TextArea autoSize={{ minRows: 1 }} status={showErrors && !(text || '').trim() ? 'error' : ''} value={text} onChange={(e) => updateNhom(x.id, index, 'noiDung', e.target.value)} /> :
                                                                <span className="text-enter">{text}</span>
                                                        }
                                                    />
                                                    <Column title="Cơ sở đào tạo" dataIndex="coSoDaoTao" key="coSoDaoTao"
                                                        render={(text, record: any, index) =>
                                                            isEditable && !record.idChiTietGoc ? <Input.TextArea autoSize={{ minRows: 1 }} status={showErrors && !(text || '').trim() ? 'error' : ''} value={text} onChange={(e) => updateNhom(x.id, index, 'coSoDaoTao', e.target.value)} /> :
                                                                <span className="text-enter">{text}</span>
                                                        }
                                                    />
                                                    <Column title="Thời gian dự kiến" dataIndex="thoiGianDuKien" key="thoiGianDuKien"
                                                        render={(text, record: any, index) =>
                                                            isEditable && !record.idChiTietGoc ? <Input.TextArea autoSize={{ minRows: 1 }} status={showErrors && !(text || '').trim() ? 'error' : ''} value={text} onChange={(e) => updateNhom(x.id, index, 'thoiGianDuKien', e.target.value)} /> :
                                                                <span className="text-enter">{text}</span>
                                                        }
                                                    />
                                                    <Column
                                                        title="Dự trù kinh phí"
                                                        dataIndex="duTruKinhPhi"
                                                        key="duTruKinhPhi"
                                                        render={(text, record, index) => {
                                                            const handleChange = (e: any) => {
                                                                updateNhom(x.id, index, 'duTruKinhPhi', e.target.value);
                                                            };
                                                            const handleBlur = (e: any) => {
                                                                const rawValue = e.target.value;

                                                                const formattedValue = rawValue.replace(/(\d[\d.,]*)/g, (match) => {
                                                                    const numeric = match.replace(/[.,]/g, '');

                                                                    if (isNaN(Number(numeric))) return match;

                                                                    return Number(numeric).toLocaleString('vi-VN');
                                                                });

                                                                updateNhom(x.id, index, 'duTruKinhPhi', formattedValue);
                                                            };

                                                            return isEditable && !(record as any).idChiTietGoc ? (
                                                                <Input.TextArea
                                                                    autoSize={{ minRows: 1 }}
                                                                    status={showErrors && !(text || '').trim() ? 'error' : ''}
                                                                    value={text}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                            ) : (
                                                                <span className="text-enter">{text}</span>
                                                            );
                                                        }}
                                                    />
                                                    <Column title="Trạng thái" dataIndex="trangThai" key="trangThai" align="center" render={(value, record) => {
                                                        return <TrangThaiTag value={record.trangThai} />
                                                    }} />
                                                    {isEditable && <Column className="text-center"
                                                        title="Xóa"
                                                        key="action"
                                                        render={(value, record: any, index) => (
                                                            record.idChiTietGoc
                                                                ? <Button danger title="Hủy" onClick={() => handleHuyThamGia(x.id, record.idChiTietGoc)} icon={<CloseOutlined rev="" />}></Button>
                                                                : <Button danger title="Xóa" onClick={() => handleXoaChiTiet(x.id, index)} icon={<DeleteOutlined rev="" />} />
                                                        )}
                                                    />}
                                                </Table>
                                        },
                                    ]}>
                                </Tabs>
                                {isEditable && showThamGia[x.id] && (loadingThamGia[x.id] || dsChuaThamGia.length > 0) &&
                                    <div className="mt-2">
                                        <div className="mb-1"><strong>Danh sách đăng ký của nhân viên khác</strong></div>
                                        <Table
                                            loading={loadingThamGia[x.id]}
                                            locale={{ emptyText: "Không có lớp nào để tham gia" }}
                                            dataSource={dsChuaThamGia}
                                            pagination={false}
                                            rowKey="id"
                                            size="small"
                                        >
                                            <Column title="STT" key="STT" render={(v, r, index) => index + 1} />
                                            <Column title="Người đăng ký" dataIndex="hoTen" key="hoTen"
                                                render={(text) => <span className="text-enter">{text}</span>} />
                                            <Column title="Chuyên đề đào tạo" dataIndex="chuyenDe" key="chuyenDe"
                                                render={(text) => <span className="text-enter">{text}</span>} />
                                            <Column title="Nội dung đào tạo" dataIndex="noiDung" key="noiDung"
                                                render={(text) => <span className="text-enter">{text}</span>} />
                                            <Column title="Cơ sở đào tạo" dataIndex="coSoDaoTao" key="coSoDaoTao"
                                                render={(text) => <span className="text-enter">{text}</span>} />
                                            <Column title="Thời gian dự kiến" dataIndex="thoiGianDuKien" key="thoiGianDuKien"
                                                render={(text) => <span className="text-enter">{text}</span>} />
                                            <Column title="Dự trù kinh phí" dataIndex="duTruKinhPhi" key="duTruKinhPhi"
                                                render={(text) => <span className="text-enter">{text}</span>} />
                                            <Column className="text-center" title="Thao tác" key="action"
                                                render={(v, record: LopThamGia) => (
                                                    <Button title="Tham gia" size="small" type="primary" icon={<CheckOutlined rev="" />} onClick={() => handleThamGia(x.id, record)}></Button>
                                                )}
                                            />
                                        </Table>
                                    </div>
                                }
                            </div>
                        </Col>
                    </Row>
                );
            })
        }
    </section >
}

export default ChiTietCaNhan;